import { useState } from "react";
import { updateVersionsForm } from "../../lib/actions"; 
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function EditApiVersionUi({ data }) {

    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    
    // 1. Initialize State from Data
    const [force, setForce] = useState(Number(data.force) === 1);
    const [isActive, setIsActive] = useState(Number(data.is_active) === 1);

    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // 2. Create FormData
        const formData = new FormData(e.target);

        // 3. Manually append toggle values
        formData.append("force", force ? "1" : "0");
        formData.append("is_active", isActive ? "1" : "0");

        const result = await updateVersionsForm(data.id, formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    const getNote = (lang) => {
        if (typeof data.release_note === 'object' && data.release_note !== null) {
            return data.release_note[lang] || "";
        }
        return ""; 
    };

    return (
        <form onSubmit={handleSubmit} className="">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                
                {/* ... Inputs remain the same ... */}
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.version") || "Version"}</label>
                    <input type="text" name="version" defaultValue={data.version} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.platform") || "Platform"}</label>
                    <select name="type" defaultValue={data.type} className="w-full px-4 py-1 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none">
                        <option value="android">Android</option>
                        <option value="ios">iOS</option>
                    </select>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.release_note_en") || "Release Note (EN)"}</label>
                    <textarea name="release_note[en]" defaultValue={getNote('en')} rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none"></textarea>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.release_note_ar") || "Release Note (AR)"}</label>
                    <textarea name="release_note[ar]" defaultValue={getNote('ar')} rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none text-right"></textarea>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.store_url") || "Store URL"}</label>
                    <input type="url" name="store_url" defaultValue={data.store_url} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>

                {/* Toggles Section - UPDATED */}
                <div className="mb-4 col-span-1 md:col-span-2 flex flex-col sm:flex-row gap-8 mt-2">

                    {/* Force Update Toggle */}
                    <div className="flex items-center justify-between bg-thirdly p-4 rounded-xl border border-white/5 w-full sm:w-1/2">
                        <span className="text-white font-medium">{t("form.force_update") || "Force Update"}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            {/* Removed hidden input and name attribute */}
                            <input 
                                type="checkbox" 
                                checked={force}
                                onChange={(e) => setForce(e.target.checked)}
                                className="sr-only peer" 
                            />
                            <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-secondary/30 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
                        </label>
                    </div>

                    {/* Is Active Toggle */}
                    <div className="flex items-center justify-between bg-thirdly p-4 rounded-xl border border-white/5 w-full sm:w-1/2">
                        <span className="text-white font-medium">{t("form.is_active") || "Is Active"}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            {/* Removed hidden input and name attribute */}
                            <input 
                                type="checkbox" 
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                                className="sr-only peer" 
                            />
                            <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-secondary/30 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
                        </label>
                    </div>

                </div>
            </div>

            <div className="flex justify-center w-full mt-8">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[20%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`}>
                    {loading ? "Saving..." : t("button.save")}
                </button>
            </div>
        </form>
    );
};